import { map, flatten, omit, concat } from 'lodash'
import { http, queryString } from 'utils'

// User mutation imports.
import { SET_GROUPS, ADD_GROUP } from 'vx/mutations'

// User state.
const state = {
  groups: []
}

// User state getters.
const getters = {
  getGroupById: (state) => (id) => {
    return state.groups.find(group => group.id === id)
  }
}

// User actions.
const actions = {

  addGroup ({ commit }, { docId, storyId, payload }) {
    return http.post(`/user-story-document/${docId}/stories/${storyId}/groups`, payload).then(response => {
      commit(ADD_GROUP, response.data)

      return response
    })
  },
}

// User state mutations.
const mutations = {

  /**
  * Set the stages state.
  */
  [SET_GROUPS] (state, groups) {
    state.groups = groups
  },

  [ADD_GROUP] (state, group) {
    state.groups.push(group)
  }
}

// Export our state, getters, actions, mutations, and modules.
export default {
  namespaced: true, state, getters, actions, mutations
}
